/**
 * Determines if an order is closed based on its status.
 *
 * @param {Object} order - The order to check.
 * @param {number} order.orderEstatus - The order status.
 *
 * @returns {boolean} True if the order status matches the closed order status, otherwise false.
 */
export function isClosedOrder({ orderEstatus }) {
  const CLOSED_ORDER_STATUS = 113;

  return orderEstatus === CLOSED_ORDER_STATUS;
}

/**
 * Finds the main order from a list of orders.
 *
 * @param {Array<Object>} orders - List of orders.
 *
 * @returns {Object} The first order that is not canceled.
 * @throws {Error} If all orders are canceled and no main order is found.
 */
export function findMainOrder(orders) {
  const CANCELED_ORDER_STATUS = 121;
  const availableOrders = orders.filter((order) => order.orderEstatus !== CANCELED_ORDER_STATUS);

  if (availableOrders.length === 0) {
    throw new Error('No main order found. All orders are cancelled.');
  }

  return availableOrders[0];
}
